<template>
  <el-dialog title="提示" :visible.sync="dialogVisible" width="760px" center :close-on-click-modal="false">
    <p class="intro">请注意以下商品标签是否正常，系统处于未打印状态</p>
    <div class="table">
      <div class="row head">
        <span>配送单NO</span>
        <span>订单号</span>
        <span>番号</span>
        <span>标签号</span>
        <span>标签状态</span>
      </div>
      <div v-for="item in rows" :key="item.key" class="row">
        <span>{{ item.no }}</span>
        <span>{{ item.orderSn }}</span>
        <span>{{ item.sorting }}</span>
        <span>{{ item.tagNo }}</span>
        <span class="warning">标签未打印</span>
      </div>
    </div>
    <span slot="footer">
      <el-button type="primary" @click="dialogVisible = false">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'UnprintedTagPrompt',
  props: {
    detail: { type: Object, required: true },
    list: { type: Array, required: true }
  },
  data() {
    return {
      dialogVisible: false,
      rows: [],
      promptedPorderSn: ''
    }
  },
  watch: {
    detail: {
      deep: true,
      handler() {
        this.check()
      }
    }
  },
  methods: {
    check() {
      // 仅在 FBA 配送单的待报价状态检查一次。
      if (Number(this.detail.status) !== 22 || !this.detail.is_fba) return
      const porderSn = this.detail.porder_sn || this.$route.query.porder_sn
      if (!porderSn || this.promptedPorderSn === porderSn) return

      this.rows = []
      this.list.forEach((item, index) => {
        const tags = Array.isArray(item.porder_detail_tag) ? item.porder_detail_tag : []
        tags.forEach(tag => {
          // is_print 为 0 或 false 时表示标签未打印。
          if (!Number(tag.is_print)) {
            this.rows.push({
              key: `${item.order_detail_id}-${tag.id}`,
              no: index + 1,
              orderSn: item.order_sn || '-',
              sorting: item.sorting || '-',
              tagNo: tag.no || '-'
            })
          }
        })
      })

      if (this.rows.length) {
        this.promptedPorderSn = porderSn
        this.dialogVisible = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.intro { margin: 0 0 14px; font-size: 16px; line-height: 24px; }
.table { border-top: 1px solid #dcdfe6; border-left: 1px solid #dcdfe6; }
.row { display: grid; grid-template-columns: .7fr 1.7fr .6fr 1fr 1fr; }
.row span { padding: 10px; border-right: 1px solid #dcdfe6; border-bottom: 1px solid #dcdfe6; text-align: center; }
.head { background: #edeff4; font-weight: bold; }
.warning { color: #b4272d; }
</style>
